import React from 'react';

const ProgramInformation = ({ onClose }) => {
  /**
   * Replace the URL below with your Google Data Studio / Looker Studio embed link.
   * To get this link: Open your report > File > Embed report > Enable embedding > 
   * Copy the URL within the 'src' attribute of the iframe code provided.
   */
  const embedUrl = "https://lookerstudio.google.com/embed/reporting/b69d762f-71a4-40e7-9069-dc6727220715/page/p_x7kzm0fkgd";

  return (
    <div className="max-w-7xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500 flex flex-col h-[calc(100vh-120px)]">
      {/* Header */}
      <div className="flex items-center justify-between gap-6 mb-8">
        <div className="flex items-center gap-4">
          <button 
            onClick={onClose} 
            className="w-10 h-10 bg-white rounded-xl shadow-sm border border-slate-200 flex items-center justify-center text-slate-400 hover:text-[#0464AD] transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </button>
          <div>
            <h2 className="text-4xl font-black text-slate-900 tracking-tighter">Program Catalogue</h2>
            <p className="text-slate-400 font-medium mt-1">Live data synchronization via Google Data Studio.</p>
          </div>
        </div>
        
        <div className="hidden md:flex items-center gap-2 px-4 py-2 bg-[#0464AD]/5 rounded-xl border border-[#0464AD]/10">
            <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
            <span className="text-[10px] font-black text-[#0464AD] uppercase tracking-widest">Live Report Connected</span>
        </div>
      </div>

      {/* Embedded Report Container */}
      <div className="flex-1 bg-white rounded-[2.5rem] shadow-sm border border-slate-200 overflow-hidden relative">
        {embedUrl === "YOUR_GOOGLE_DATA_STUDIO_LINK_HERE" ? (
          <div className="absolute inset-0 flex flex-col items-center justify-center p-10 text-center space-y-4">
            <div className="w-20 h-20 bg-slate-50 rounded-3xl flex items-center justify-center text-4xl mb-2">📊</div>
            <h3 className="text-xl font-black text-slate-900 tracking-tighter uppercase">Link Required</h3>
            <p className="max-w-md text-sm text-slate-400 font-medium leading-relaxed">
              Please provide your Google Data Studio embed URL in the <code className="bg-slate-100 px-1 rounded font-bold">ProgramInformation.js</code> file to view the live catalogue.
            </p>
          </div>
        ) : (
          <iframe
            title="Program Catalogue Report"
            width="100%"
            height="100%"
            src={embedUrl}
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          ></iframe>
        )}
      </div>

      <div className="mt-4 flex justify-between items-center text-[10px] font-black text-slate-300 uppercase tracking-[0.2em] px-4">
          <span>External Data Provider: Looker Studio</span>
          <span className="flex items-center gap-2">
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
              Encrypted Connection
          </span>
      </div>
    </div>
  );
};

export default ProgramInformation;